export enum ITLeasingLinks {
  LOGIN = 'https://admin.own-it.de/registration?referrer=probonio',
  HR_SUPPORT_MAIL_TO = 'mailto:hr-support@own-it.de',
}
